import {
  IMienGiamSoTienDuyetRequest,
  IMienGiamSoTienPagingRequest,
  IMienGiamSoTienSaveRequest,
} from "../../model/request/mien-giam/IMienGiamSoTienRequest";
import { apiClient } from "../apiClient";

export const MIEN_GIAM_SO_TIEN_ENDPOINT = "mien-giam-so-tien";

export const mienGiamSoTienApi = {
  SelectPaging: (request: IMienGiamSoTienPagingRequest) =>
    apiClient.post(`${MIEN_GIAM_SO_TIEN_ENDPOINT}/select-paging`, request),

  /** Lưu nhiều dòng; `is_duyet` = true là "lưu và duyệt". */
  Saves: (request: IMienGiamSoTienSaveRequest) =>
    apiClient.post(`${MIEN_GIAM_SO_TIEN_ENDPOINT}/saves`, request),

  SetDuyet: (request: IMienGiamSoTienDuyetRequest) =>
    apiClient.post(`${MIEN_GIAM_SO_TIEN_ENDPOINT}/set-duyet`, request),

  Deletes: (ids: number[]) =>
    apiClient.post(`${MIEN_GIAM_SO_TIEN_ENDPOINT}/deletes`, ids),
};
